export default __webpack_public_path__ + "static/media/Wholesale4.0a9084c7.jpg";